import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import TeamIndexPage from '@/pages/team/TeamIndexPage.vue';
import { RouteLocation } from 'vue-router';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: 'team',
  beforeEnter: authGuard,
  meta: {
    displayNav: true,
  },
  children: [
    {
      path: '',
      name: RouteNames.TEAM.INDEX,
      component: TeamIndexPage,
      props: (route) => ({
        openInviteModal: route.query.openInviteModal === 'true',
      }),
      beforeEnter: (_to: RouteLocation) => {
        return true;
      },
    },
  ],
});
